import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  CTA,
  CustomInput,
  CustomSelect,
  NoResult,
  Text,
} from '../../../../ui/atoms';
import {
  FiltersContainer,
  Filter,
  SelectsContainer,
  ResultsSorting,
  Legend,
  ScormCard,
} from '../style';
import { flattenCategories } from '../../../../utils/categories';
import Pagination from '../../../../ui/atoms/Pagination';
import SortBy from '../../../../ui/atoms/SortBy';
import { DURATION_OPTIONS } from '../../../../utils/labels';
import { withMediaQueries } from '../../../hoc/withMediaQueries';
import { StickyFiltersWrapper } from '../../../../ui/atoms/CTA/style';
import { MODAL_OPEN } from '../../../redux/actions';
import ModalFilters, {
  ModalFiltersId,
} from '../../../../ui/atoms/Modals/ModalFilters';
import { SCORM_LIST_GET } from '../../../redux/actions/scorm';
import { convertDuration } from '../../../../utils/common';
import ModalPreviewScorm, {
  ModalPreviewScormId,
} from '../../../../ui/atoms/Modals/ModalPreviewScorm';

const ScormResults = ({
  mediaIsPhone,
  mediaIsTablet,
  currentArea,
  list,
  filters,
  pager,
  getScormList,
  modalOpen,
}) => {
  const [subjects, setSubjects] = useState([]);
  // filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    return () => {
      setSelectedFilters({});
      setSubjects([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetCourses = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      parent_categories: currentArea?.id,
      single_categories: selectedFilters?.subject,
      page,
    };
    if (parsedFilters?.subject) {
      delete parsedFilters?.parent_categories;
      delete parsedFilters.subject;
    }
    getScormList(parsedFilters);
  };

  useEffect(() => {
    if (currentArea?.id) {
      const newSubjects = flattenCategories(currentArea?.children, 0, true);
      setSubjects(newSubjects);
    } else setSubjects([]);
    setSelectedFilters({ ...selectedFilters, subject: undefined });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentArea]);

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) handleGetCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetCourses(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <>
      {mediaIsPhone ? (
        <StickyFiltersWrapper mb={16} stickyPosition={1}>
          <CustomInput
            placeholder="Cosa vuoi cercare?..."
            isSearch
            value=""
            icon="search-sm"
            isClearable
            onChange={(v) => setSearchValue(v)}
            onClickIcon={onClickSearch}
            onKeyPress={(event) => {
              if (event.key === 'Enter') onClickSearch();
            }}
          />
          <CTA
            classes="small-btn"
            btnText="Filtri"
            type="secondary"
            fullsize
            onClick={() =>
              modalOpen(ModalFiltersId, {
                filters: {
                  subject: subjects,
                  ...filters,
                  duration: DURATION_OPTIONS,
                },
                activeFilters: selectedFilters,
              })
            }
          />
        </StickyFiltersWrapper>
      ) : (
        <>
          <FiltersContainer>
            <SelectsContainer>
              <Filter>
                <CustomInput
                  placeholder="Cosa vuoi cercare?..."
                  isSearch
                  value=""
                  icon="search-sm"
                  isClearable
                  onChange={(v) => setSearchValue(v)}
                  onClickIcon={onClickSearch}
                  onKeyPress={(event) => {
                    if (event.key === 'Enter') onClickSearch();
                  }}
                />
              </Filter>
              {subjects?.length > 0 && (
                <Filter>
                  <CustomSelect
                    size="s"
                    placeholder="Materia"
                    options={subjects}
                    isClearable
                    onChange={(v) =>
                      setSelectedFilters({
                        ...selectedFilters,
                        subject: v?.value,
                      })
                    }
                    selected={
                      subjects?.find(
                        (s) => s.value === selectedFilters?.subject
                      ) ?? null
                    }
                  />
                </Filter>
              )}
              <Filter>
                <CustomSelect
                  size="s"
                  placeholder="Durata"
                  options={DURATION_OPTIONS}
                  isClearable
                  onChange={(v) =>
                    setSelectedFilters({
                      ...selectedFilters,
                      duration: v?.value,
                    })
                  }
                />
              </Filter>
            </SelectsContainer>
          </FiltersContainer>
          <ResultsSorting>
            <Text type="b3">
              {pager?.total_items || 0} attività disponibili
            </Text>
            <SortBy
              onChange={(v) => {
                setSelectedFilters({
                  ...selectedFilters,
                  sort_by: v?.value,
                });
              }}
            />
          </ResultsSorting>
        </>
      )}
      {mediaIsPhone && (
        <Text type="b3" mb={32}>
          {pager?.total_items || 0} attività disponibili
        </Text>
      )}
      {!(mediaIsPhone || mediaIsTablet) && (
        <Legend>
          <Text type="h3.5">Codice</Text>
          <Text type="h3.5">Titolo</Text>
          <Text type="h3.5">Materia</Text>
          <Text type="h3.5">Durata</Text>
        </Legend>
      )}
      {list?.length > 0 ? (
        list.map((item, i) => {
          if (mediaIsPhone || mediaIsTablet) {
            return (
              <ScormCard
                key={`scorm-${item?.id}`}
                className={list?.length === i + 1 ? 'last' : ''}
              >
                <Text type="h5">Codice</Text>
                <div className="code">{item?.code}</div>
                <Text type="h5">Titolo</Text>
                <Text type="h3">{item.title}</Text>
                <Text type="h5">Materia</Text>
                <div className="date ellipsis">
                  {!item?.category && '-'}
                  {(item?.category || []).map((t, index) => (
                    <span key={`category-${index}`}>
                      {index > 0 && <span> - </span>}
                      {t?.label}
                    </span>
                  ))}
                </div>
                <Text type="h5">Durata</Text>
                <div className="duration">
                  {convertDuration(item?.duration)}
                </div>
                <div />
                <CTA
                  type="tertiary"
                  btnText="Visualizza anteprima"
                  icon="eye"
                  onClick={() =>
                    modalOpen(ModalPreviewScormId, { scormId: item?.id })
                  }
                  bottomRight
                />
              </ScormCard>
            );
          }
          return (
            <ScormCard
              key={`scorm-${item?.id}`}
              className={list?.length === i + 1 ? 'last' : ''}
            >
              <div className="code">{item?.code}</div>
              <Text type="h3">{item.title}</Text>
              <div className="date ellipsis">
                {!item?.category && '-'}
                {(item?.category || []).map((t, index) => (
                  <span key={`category-${index}`}>
                    {index > 0 && <span> - </span>}
                    {t?.label}
                  </span>
                ))}
              </div>
              <div className="duration">{convertDuration(item?.duration)}</div>
              <CTA
                type="tertiary"
                btnText="Visualizza anteprima"
                icon="eye"
                onClick={() =>
                  modalOpen(ModalPreviewScormId, { scormId: item?.id })
                }
              />
            </ScormCard>
          );
        })
      ) : (
        <NoResult />
      )}
      <Pagination
        pager={pager}
        callBack={loadMore}
        setItemsPerPage={setItemsPerPage}
      />
      {mediaIsPhone && (
        <ModalFilters
          onClick={(newFilters) =>
            setSelectedFilters({
              ...newFilters,
              search_text: selectedFilters.search_text,
            })
          }
        />
      )}
      <ModalPreviewScorm />
    </>
  );
};

ScormResults.propTypes = {
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  currentArea: PropTypes.object,
  // HOC (connect, state)
  list: PropTypes.array.isRequired,
  filters: PropTypes.object,
  pager: PropTypes.object.isRequired,
  // HOC (connect, dispatch)
  getScormList: PropTypes.func.isRequired,
  modalOpen: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { list = [], filters, pager = {} } = state.scorm;
      return {
        list,
        filters,
        pager,
      };
    },
    (dispatch) => ({
      getScormList: (filters) =>
        dispatch({
          type: SCORM_LIST_GET._REQUEST,
          filters,
        }),
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    })
  ),
  withMediaQueries
)(ScormResults);
